export default {
  users: {
    createUser: '/v2/users',
    getUsernames: '/v2/users/usernames',
    authenticateUser: '/v2/authenticate',
    plainUser: '/v2/users/plain',
    refresh: '/v2/authenticate/authenticate/refresh',
    confirmForgotPassword: '/v2/users/passwords/reset_token',
    resetPassword: '/v2/users/passwords',
    generateToken: '/v2/authenticate/authenticate/generate',
    getBasicAccount:
      'v2/basic-accounts/{applicationUid}/accounts/{accountUid}/details',
    getEncryptedEmail: '/v2/users/uids',
    getDecryptedEmail: '/v2/users/emails',
  },
  salesAssisted: {
    authenticateUser: '/v2/sales/authenticate',
    fetchApplications: '/v2/sales/users/applications',
    userInfo:
      '/v2/sales/applications/invitations?invitationToken={invitationToken}',
    sendInvite: '/v2/sales/applications/{applicationUid}/invitations',
    setPassword: '/v2/sales/passwords',
  },
  persons: {
    postPersonName: '/v2/applications/{ApplicationUid}/persons',
    putPersonName:
      '/v2/applications/{ApplicationUid}/persons/{PersonUid}/names',
    postPersonSSN: '/v2/applications/{ApplicationUid}/persons/{PersonUid}/ssns',
    putPersonSSN: '/v2/applications/{ApplicationUid}/persons/{PersonUid}/ssns',
    postPersonAddress:
      '/v2/applications/{ApplicationUid}/persons/{PersonUid}/addresses',
    putPersonAddress:
      '/v2/applications/{ApplicationUid}/persons/{PersonUid}/addresses',
    postPersonBirthday:
      '/v2/applications/{ApplicationUid}/persons/{PersonUid}/birthdays',
    putPersonBirthday:
      '/v2/applications/{ApplicationUid}/persons/{PersonUid}/birthdays',
    postPersonCountry:
      '/v2/applications/{ApplicationUid}/persons/{PersonUid}/countries',
    putPersonCountry:
      '/v2/applications/{ApplicationUid}/persons/{PersonUid}/countries',
    postPersonBackupHoldings:
      '/v2/applications/{ApplicationUid}/persons/backup-withholdings',
    putPersonBackupHoldings:
      '/v2/applications/{ApplicationUid}/persons/backup-withholdings',
    postPersonPhone:
      '/v2/applications/{ApplicationUid}/persons/{PersonUid}/phones',
    putPersonPhone:
      '/v2/applications/{ApplicationUid}/persons/{PersonUid}/phones',
    postLegalEntityEin: '/v2/applications/{ApplicationUid}/legal-entities/eins',
    putLegalEntityEin: '/v2/applications/{ApplicationUid}/legal-entities/eins',
    postLegalEntityName: '/v2/applications/{ApplicationUid}/legal-entities',
    putLegalEntityName:
      '/v2/applications/{ApplicationUid}/legal-entities/names',
    postLegalEntityAddress:
      '/v2/applications/{ApplicationUid}/legal-entities/addresses',
    putLegalEntityAddress:
      '/v2/applications/{ApplicationUid}/legal-entities/addresses',
    maritalStatus:
      '/v2/applications/{ApplicationUid}/persons/{PersonUid}/marital-statuses',
  },
  metalStream: {
    getProducts: 'v2/applications/{ApplicationUid}/metal-streams/products',
    postAllocations:
      'v2/applications/{ApplicationUid}/metal-streams/allocations',
    putAllocations:
      'v2/applications/{ApplicationUid}/metal-streams/allocations',
    postProducts: 'v2/applications/{ApplicationUid}/metal-streams/products',
    putProducts: 'v2/applications/{ApplicationUid}/metal-streams/products',
    postAmount: 'v2/applications/{ApplicationUid}/metal-streams/fundings',
    putAmount: 'v2/applications/{ApplicationUid}/metal-streams/fundings',
    postBankAccount:
      'v2/applications/{ApplicationUid}/bank-accounts/metal-streams',
    bankApplicationFunding:
      '/v2/applications/{ApplicationUid}/metal-streams/bank-application-fundings',
  },
  bankAccounts: {
    getBankAccounts: 'v2/applications/{ApplicationUid}/bank-accounts',
    postBankAccount:
      'v2/applications/{ApplicationUid}/bank-accounts/plaid-bank-accounts',
  },
  iraFunding: {
    accountNumber:
      'v2/applications/{ApplicationUid}/ira-transfers/account-number',
    fundingAmount:
      'v2/applications/{ApplicationUid}/ira-application-funding-amounts',
    transferType:
      'v2/applications/{ApplicationUid}/ira-transfers/transfer-types',
    fundingType: 'v2/applications/{ApplicationUid}/ira-application-fundings',
    accountType:
      'v2/applications/{ApplicationUid}/ira-transfers/ira-account-types',
    paymentDeliveryType:
      'v2/applications/{ApplicationUid}/ira-transfers/payment-delivery-types',
  },
  funding: {
    applicationFunding: 'v2/applications/{ApplicationUid}/application-fundings',
    bankApplicationFunding:
      'v2/applications/{ApplicationUid}/bank-application-fundings',
    applicationFundingAmount: '/v2/applications/{ApplicationUid}/fundings',
    bankApplicationFundingAmount:
      '/v2/applications/{ApplicationUid}/bank-application-funding-amounts',
    postMetalStreamFunding:
      'v2/applications/{ApplicationUid}/metal-streams/fundings-sources',
    updateMetalStreamFunding:
      'v2/applications/{ApplicationUid}/metal-streams/fundings-sources',
  },
  countries: 'countries',
  settings: {
    get: 'v2/settings',
  },
  custodians: {
    getCustodians: 'v2/custodians',
    custodian: '/v2/custodians/applications/{ApplicationUid}',
    custodianAccountNumber:
      '/v2/custodians/applications/{ApplicationUid}/ira-transfers/account-numbers',
  },
  applications: {
    getApplication: 'v2/applications/{ApplicationUid}', // Get Application Endpoint
    deleteApplication: 'v2/applications/{ApplicationUid}', // Delete Application Endpoint
    createApplicationStep: 'v2/applications/{ApplicationUid}/steps', // Create Application Steps TO ADD
    createApplication: 'v2/applications', // Create Application Endpoint
    patchApplication: 'v2/applications/{ApplicationUid}?sessionId={sessionId}', // Complete Application Endpoint
    createApplicationType: 'v2/applications/{ApplicationUid}/types', // Create Application Type Endpoint
    createAccountType: '/v2/applications/{ApplicationUid}/account-types', // Create Account Type Endpoint
    patchAccountType: '/v2/applications/{ApplicationUid}/account-types', // Patch Account Type Endpoint
    upgradeApplication: '/v2/basic-accounts/upgrade/{applicationUid}', // Upgrade Application
  },
  agreements: {
    achAgreement: '/v2/applications/{ApplicationUid}/ach-agreements',
    haaAgreement: '/v2/applications/{ApplicationUid}/haa-agreements',
    iraAgreement: '/v2/applications/{ApplicationUid}/ira-agreements',
    metalStreamAgreement:
      '/v2/applications/{ApplicationUid}/metal-stream-agreements',
    download: {
      achAgreement: '/v2/applications/{ApplicationUid}/ach-html-agreements',
      haaAgreement: '/v2/applications/{ApplicationUid}/haa-html-agreements',
      iraAgreement: '/v2/applications/{ApplicationUid}/ira-html-agreements',
      metalStreamAgreement:
        '/v2/applications/{ApplicationUid}/metal-stream-html-agreements',
    },
    downloadPdf: {
      achAgreement: '/v2/applications/{ApplicationUid}/ach-pdf-agreements',
      haaAgreement: '/v2/applications/{ApplicationUid}/haa-pdf-agreements',
      iraAgreement: '/v2/applications/{ApplicationUid}/ira-pdf-agreements',
      metalStreamAgreement:
        '/v2/applications/{ApplicationUid}/metal-stream-pdf-agreements',
    },
  },
  common: {
    getCountries: 'v2/countries?countryListType={countryListType}',
    getCountryStates:
      'v2/countries/{countryCode}/states?stateListType={stateListType}',
  },
  plaid: {
    getToken:
      'v2/applications/{ApplicationUid}/bank-accounts/plaid-link-tokens',
  },
  affiliate: {
    setFingerprint: 'v2/tracking-details/fingerprints',
    saveTrackingDetails: 'v2/tracking-details',
  },
  documents: {
    documents: 'v2/applications/{ApplicationUid}/documents',
    requiredDocuments:
      '/v2/applications/{ApplicationUid}/documents/required-documents',
    socureEvent: '/v2/documents/socure-event',
  },
  funding_source: {
    getFundingSource: 'v2/customer-due-diligence/funding-source-types',
    applicationFundingSource:
      'v2/customer-due-diligence/{applicationUid}/account-funding',
    getAccountPurposeSource: 'v2/customer-due-diligence/account-purpose-types',
  },
  employment: {
    getStatusList: '/v2/customer-due-diligence/employment-statuses',
    getOccupationCategories: 'v2/customer-due-diligence/occupations',
    info: '/v2/customer-due-diligence/{ApplicationUid}/employment-info',
    incomeSource: '/v2/customer-due-diligence/income-source-types',
  },
  identificationVerification: {
    getIdentificationTypesSource:
      'v2/customer-due-diligence/identification-types',
    getAllStates: 'v2/customer-due-diligence/states',
    getAllCountries: 'v2/customer-due-diligence/countries',
    identifcationInfo:
      '/v2/customer-due-diligence/{applicationUid}/identification-info',
  },
  crmEvents: {
    main: '/v2/crm/{applicationUid}/crmevents',
    postSaveNExit: '/v2/crm/{applicationUid}/exitModal',
  },
};
